import {getTomorrow, getTomorrowFormat} from "./assets/PieDate";

export default function PersonalData({setData, form}) {

    const setDate = (e) => {
        const dateString = e.target.value

        const inputDate = new Date(dateString); //dd-mm-YYYY
        const tomorrowDate = getTomorrow()
        if (inputDate < tomorrowDate) {
            e.target.value = getTomorrowFormat()
        }

        setData({date: e.target.value})
    }

    const getTimeOptions = () => {
        let values = [];
        for (let i = 8; i <= 22; i++) {
            for (let j = 0; j <= 45; j += 15) {
                values.push(i + ':' + (j === 0 ? '00' : j));
                if (i === 22) {
                    break;
                }
            }
        }
        return values.map((item, key) => {
            return (
                <option key={'top_opt_' + key} value={item}>{item}</option>
            );
        })
    }

    return (
        <>
            <div className={'flex'}>
                <div className={'column'}>
                    <div className={'flex'}>
                        <div className={'column inputContent'}>
                            <label>Event date</label>
                            <input type={"date"} className={"form-control"}
                                   value={form?.date}
                                   onChange={(e) => setDate(e)}
                            />
                        </div>
                        <div className={'column inputContent'}>
                            <label>Event time</label>
                            <select className={"form-control"}
                                    value={form?.time ?? ''}
                                    onChange={(e) => setData({time: e.target.value})}>
                                {getTimeOptions()}
                            </select>
                        </div>
                    </div>
                </div>
                <div className={'column'}>
                    <div className={'inputContent'}>
                        <label>Name*</label>
                        <input type={"text"} className={"form-control"}
                               value={form?.user_name}
                               onChange={(e) => setData({user_name: e.target.value})}
                               required
                        />
                    </div>
                    <div className={'inputContent'}>
                        <label>Company</label>
                        <input type={"text"} className={"form-control"}
                               value={form?.user_company}
                               onChange={(e) => setData({user_company: e.target.value})}
                        />
                    </div>
                </div>
                <div className={'column'}>
                    <div className={'inputContent'}>
                        <label>E-mail address*</label>
                        <input type={"text"} className={"form-control"}
                               value={form?.user_email}
                               onChange={(e) => setData({user_email: e.target.value})}
                               required
                        />
                    </div>
                    <div className={'inputContent'}>
                        <label>Phone number*</label>
                        <input type={"text"} className={"form-control"}
                               value={form?.user_phone}
                               onChange={(e) => setData({user_phone: e.target.value})}
                               required
                        />
                    </div>
                </div>
            </div>
            <div>
                <div className={'col-12'}>
                                    <textarea className={"form-control"}
                                              placeholder={"Enter your questions, special requests"}
                                              onChange={(e) => setData({comment: e.target.value})}
                                              value={form?.comment ?? ''}
                                    > </textarea>
                </div>
            </div>
        </>
    );
}